import React, { useContext } from 'react';
import AppContext from 'context/Context';
import useToken from 'hooks/useToken';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCog,
  faBolt,
  faTags,
  faArrowLeft,
  faTimes,
  faClock,
  faRobot,
  faGlobe
} from '@fortawesome/free-solid-svg-icons';

const SupportEngineSettingsSidebar = ({
  activeSubTab = 'atajos',
  setActiveSubTab,
  isOpen = false,
  onClose,
  onBack
}) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const { idCatTipoUsuario } = useToken();
  const isAdmin = Number(idCatTipoUsuario) === 1;

  const menuItems = [
    {
      id: 'atajos',
      label: 'Atajos',
      icon: faBolt,
      activeColor: '#059669',
      badge: null
    },
    {
      id: 'incidencias',
      label: 'Incidencias',
      icon: faTags,
      activeColor: '#2563eb',
      badge: null
    },
    ...(isAdmin ? [{
      id: 'horarios',
      label: 'Horarios',
      icon: faClock,
      activeColor: '#2563eb',
      badge: null
    }] : []),
    {
      id: 'mensajes',
      label: 'Mensajes Automáticos',
      icon: faRobot,
      activeColor: '#2563eb',
      badge: null
    },
    ...(isAdmin ? [{
      id: 'globales',
      label: 'Globales',
      icon: faGlobe,
      activeColor: '#2563eb',
      badge: null
    }] : [])
  ];

  return (
    <aside
      className={`se-subsidebar ${isOpen ? 'se-subsidebar-open' : ''}`}
      style={{
        backgroundColor: isDark ? '#121e2d' : '#ffffff',
        borderColor: isDark ? '#233142' : '#e2e8f0'
      }}
    >
      {/* Sub-sidebar Header */}
      <div
        className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom"
        style={{ borderColor: isDark ? '#233142' : '#e2e8f0' }}
      >
        {/* Botón volver visible en móvil */}
        {onBack && (
          <button
            type="button"
            className="btn btn-sm border-0 d-lg-none d-flex align-items-center justify-content-center rounded-circle p-0"
            onClick={onBack}
            style={{
              width: '32px',
              height: '32px',
              minWidth: '32px',
              backgroundColor: isDark ? '#1e293b' : '#f1f5f9',
              color: isDark ? '#94a3b8' : '#64748b'
            }}
            aria-label="Volver al menú principal"
            title="Volver al menú principal"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
        )}

        <div
          className="d-flex align-items-center justify-content-center rounded-2 flex-shrink-0"
          style={{
            width: '32px',
            height: '32px',
            minWidth: '32px',
            backgroundColor: isDark ? '#1e293b' : '#e0e7ff',
            color: isDark ? '#818cf8' : '#4338ca'
          }}
        >
          <FontAwesomeIcon icon={faCog} style={{ fontSize: '0.95rem' }} />
        </div>

        <div>
          <h6
            className="fw-bold mb-0"
            style={{
              fontSize: '0.95rem',
              lineHeight: 1.2,
              color: isDark ? '#f9fafd' : '#0f172a'
            }}
          >
            Configuración
          </h6>
          <small
            className="text-muted"
            style={{ fontSize: '0.72rem', color: isDark ? '#94a3b8' : '#64748b' }}
          >
            Mesa de Ayuda
          </small>
        </div>

        {/* Botón cerrar visible solo en móvil */}
        {onClose && (
          <button
            type="button"
            className="btn btn-sm border-0 d-lg-none ms-auto d-flex align-items-center justify-content-center rounded-circle p-0"
            onClick={onClose}
            style={{
              width: '32px',
              height: '32px',
              minWidth: '32px',
              backgroundColor: isDark ? '#1e293b' : '#f1f5f9',
              color: isDark ? '#94a3b8' : '#64748b'
            }}
            aria-label="Cerrar menú"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}
      </div>

      {/* Submenu Items - Styled exactly like the main sidebar */}
      <nav className="d-flex flex-column gap-1 flex-grow-1">
        {menuItems.map(item => {
          const isActive = activeSubTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => {
                setActiveSubTab(item.id);
                if (onClose) onClose();
              }}
              className={`se-nav-btn text-decoration-none d-flex justify-content-between align-items-center ${isActive ? 'active' : ''}`}
            >
              <div className="d-flex align-items-center gap-2">
                <FontAwesomeIcon
                  icon={item.icon}
                  style={{
                    color: isActive ? item.activeColor || '#4338ca' : (isDark ? '#94a3b8' : '#64748b'),
                    width: '18px'
                  }}
                />
                <span style={{ color: isActive ? (isDark ? '#f8fafc' : '#1e293b') : (isDark ? '#94a3b8' : '#64748b') }}>
                  {item.label}
                </span>
              </div>
            </button>
          );
        })}
      </nav>

      {/* Opción para regresar al menú principal en móvil */}
      {onBack && (
        <div
          className="pt-3 border-top mt-auto d-lg-none"
          style={{ borderColor: isDark ? '#233142' : '#e2e8f0' }}
        >
          <button
            type="button"
            onClick={onBack}
            className="se-nav-btn w-100 d-flex align-items-center gap-2"
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              style={{ color: isDark ? '#94a3b8' : '#64748b', width: '16px' }}
            />
            <span style={{ fontSize: '0.85rem', color: isDark ? '#94a3b8' : '#64748b' }}>
              Menú Principal
            </span>
          </button>
        </div>
      )}
    </aside>
  );
};

export default SupportEngineSettingsSidebar;
